import { Container, Grid, Typography } from "@mui/material";
import styled from "styled-components";

export const StyledBox = styled.section`
  && {
    width: 100%;
    background-color: #f5f5f5;
  }
`;

export const CustomContainer = styled(Container)`
  && {
    position: relative;
    padding-top: clamp(40px, 8vw, 100px);
    padding-bottom: clamp(40px, 6vw, 80px);
    padding-left: 24px;
    padding-right: 24px;
  }

  @media screen and (max-width: 720px) {
    && {
      padding-top: 40px;
      padding-left: 15px;
      padding-right: 15px;
      padding-bottom: 32px;
    }
  }
`;

export const TitleContainer = styled(Grid)`
  && {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Title = styled(Typography).attrs({ as: "h2" })`
  && {
    max-width: 920px;
    margin: 0 0 20px;

    font-family: Figtree, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: clamp(1.6rem, 2.5vw + 1rem, 2.5rem);
    line-height: 1.25;

    text-align: center;
    color: #0b234c;
  }
`;

export const SubTitle = styled(Typography).attrs({ as: "p" })`
  && {
    max-width: 850px;
    margin: 0;

    font-family: Figtree, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: clamp(1rem, 1.2vw + 0.8rem, 1.5625rem);
    line-height: 1.3;

    text-align: center;
    color: #0b234c;
  }
`;

export const Observation = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 0;
    padding-bottom: 18px;

    font-family: Figtree, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 32px;

    text-align: center;
    color: #0b234c;
  }
`;